import envUrls from "../config/env-urls";

const REACT_APP_ENV = process.env.REACT_APP_ENV || "dev";
const reportBaseURL = envUrls[REACT_APP_ENV].API.reportBaseURL;

export const getNewReportFullPath = (newReportUrl) => {
  if (!newReportUrl) {
    return null;
  }
  return newReportUrl.startsWith("http")
    ? newReportUrl
    : `${reportBaseURL}${newReportUrl}`;
};

/** Open modern report portal in a new browser tab (e.g. qareports.innofulfill.com). */
export const openNewReportPortal = (newReportUrl) => {
  const newReportFullPath = getNewReportFullPath(newReportUrl);
  if (!newReportFullPath) {
    return false;
  }
  window.open(newReportFullPath, "_blank", "noopener,noreferrer");
  return true;
};
